var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var edit = require('../layout/components/edit');
var pathHeader = require('../layout/components/pathHeader');
var equipmentDiagram = require('../equipment/components/equipmentDiagram');
var addDiagramEquipmentModal = require('./addDiagramEquipmentModal');
var rowActionDropdown = require('../components/rowActionDropdown');
var componentDatasetVisibilityTable = require('../equipment/components/componentDatasetVisibilityTable');

var diagramDetail = {};

function getOwnerLocation(diagramRecord) {
  var ownerEdges = diagramRecord && diagramRecord.in_hasDiagram;
  if (!Array.isArray(ownerEdges) || ownerEdges.length === 0) return null;
  return ownerEdges[0] && ownerEdges[0].out;
}

diagramDetail.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Diagram';
  ctrl.diagramRecord = prop();
  ctrl.diagram = prop({});
  ctrl.redrawDiagram = prop(false);
  ctrl.pendingSelectedEquipmentRid = prop(null);

  ctrl.init = function () {
    ctrl.diagramRecordRid = m.route.param('id');
    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/diagram/' + ctrl.diagramRecordRid,
      method: 'GET'
    })
    .then(function (record) {
      record.path = Array.isArray(record.path) ? record.path : [];
      record.path.forEach(function (pathRecord) {
        if (pathRecord && !pathRecord.name) pathRecord.name = pathRecord['@class'];
      });
      if (!record.path.find(function (pathRecord) { return pathRecord && pathRecord['@rid'] === record['@rid']; })) {
        record.path.push(record);
      }
      ctrl.diagramRecord(record);
      m.redraw();
    });
  };

  ctrl.initAndRedrawDiagram = async function (options) {
    if (options && Array.isArray(options.equipmentRids) && options.equipmentRids.length) {
      ctrl.pendingSelectedEquipmentRid(options.equipmentRids);
    } else if (options && options.equipmentRid) {
      ctrl.pendingSelectedEquipmentRid(options.equipmentRid);
    }
    await ctrl.init();
    ctrl.redrawDiagram(true);
    m.redraw();
  };

  ctrl.deleteDiagram = function () {
    var diagramRecord = ctrl.diagramRecord();
    var ownerLocation = getOwnerLocation(diagramRecord);
    if (!diagramRecord || !window.confirm('Delete this diagram?')) return;
    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/diagram/' + diagramRecord['@rid'].slice(1),
      method: 'DELETE'
    })
    .then(function () {
      if (ownerLocation && ownerLocation['@rid']) {
        m.route.set('/location/' + ownerLocation['@rid'].slice(1));
      } else {
        m.route.set('/location');
      }
    });
  };

  ctrl.init();
};

diagramDetail.onupdate = function () {
  var ctrl = this;
  if (ctrl.diagramRecordRid !== m.route.param('id')) {
    ctrl.diagram(undefined);
    ctrl.init();
  }
};

diagramDetail.view = function () {
  var ctrl = this;
  var diagramRecord = ctrl.diagramRecord();
  if (!diagramRecord) return m('div');

  return m('div.mh3.mv3', [
    m(pathHeader, {
      ancestors: diagramRecord.path,
      record: diagramRecord,
      class: '.flex.justify-between.display',
    }, [
      edit.vm.editing() ?
        m(rowActionDropdown, {
          items: [
            {
              label: 'Add Equipment',
              icon: 'ion-plus',
              onclick: addDiagramEquipmentModal.open.bind(addDiagramEquipmentModal, diagramRecord, { submitCallback: ctrl.initAndRedrawDiagram })
            },
            {
              label: 'Delete Diagram',
              icon: 'ion-trash-a',
              onclick: ctrl.deleteDiagram
            }
          ]
        })
        : m('div')
    ]),
    edit.vm.editing() ?
      m('div.mb2', [
        m('div.dib.ba.b--blue.b--dashed.bw1.ph3.pv2.pointer', {
          onclick: addDiagramEquipmentModal.open.bind(addDiagramEquipmentModal, diagramRecord, { submitCallback: ctrl.initAndRedrawDiagram })
        }, [
          m('div.flex.justify-center.blue', [
            m('i.ion-plus.mr2'),
            m('div', 'Add Equipment')
          ])
        ])
      ])
      : '',
    edit.vm.editing() ?
      m(componentDatasetVisibilityTable, {
        parentRecord: diagramRecord,
        edgeName: 'out_hasDiagramEquipment',
        title: 'Dataset Visibility',
        containerClass: 'mb3',
        onSaved: ctrl.initAndRedrawDiagram
      })
      : '',
    m('div', { style: { height: '70vh', position: 'relative' } }, [
      m(equipmentDiagram, {
        equipmentRecord: ctrl.diagramRecord,
        parentReinitialize: ctrl.init,
        parentReinitializeAndRedraw: ctrl.initAndRedrawDiagram,
        redrawDiagram: ctrl.redrawDiagram,
        selectedEquipmentRid: ctrl.pendingSelectedEquipmentRid,
        diagram: ctrl.diagram,
        parentCtrl: ctrl,
        isDiagram: true,
        useGeoPositioning: false
      })
    ])
  ]);
};

module.exports = diagramDetail;
